<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      alert-type="error" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row
      class="fill-height"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="generateAccessToken"
          @submit.prevent
        >
          <v-card
            max-width="800"
            elevation="0"
            rounded="xxl"
            color="background"
          > 
            <v-card-title class="text-h5 font-weight-bold text-center justify-center mb-4 no-break">
              {{ $t('generateAccessTokenTitle') }}
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="name"
                solo
                hide-details="auto"
                class="rounded-xxl text-body-2"
                :placeholder="$t('createSpaceNamePlaceholder')"
                :rules="nameRules"
                data-testid="name-input"
              />
            </v-card-text>
          </v-card>
          <v-row>
            <v-col align="center">
              <FormFooter
                next-button-text="generate"
                :loading="loading"
                cancel-button-link="/space/api"
                @proceedSubmit="generateAccessToken"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import FormFooter  from '../../components/FormFooter'
import { ruleRequired, ruleValidMin2Max70Characters } from '../../rules/formRules.js';
import AlertMessages  from '../../components/AlertMessages'
import { generateAccessToken } from '../../api/spaceApi'

export default {
    components: {
        FormFooter,
        AlertMessages
    },
    data(){
        return{
            valid: true,
            name: '',
            nameRules: ruleRequired('labelName').concat(ruleValidMin2Max70Characters('labelName')),
            alertMsg:'',
            alertValue:false,
            spaceId: window.$cookies.get('space_id'),
            loading: false
        }
    },
    methods: {
        async generateAccessToken(){
            this.$refs.form.validate()
            if(this.valid){
                this.loading =true
                try {
                    let data = {
                        data: {
                            attributes: {
                                name: this.name.trim()
                            }
                        }
                    };
                    var response = await generateAccessToken(this.spaceId, data);
                    if(response){
                        if(response.status == 200) {
                            this.$router.push({name: 'SpaceAPI', params: { successfullyGeneratedAccessToken: true, token: response.data.meta.access_token, id: response.data.meta.id}})
                        }
                    }
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                        if (e.response.status == 403){
                            this.$router.push({name: 'PageAccessDenied'})
                        } else{
                            this.alertMsg =  i18n.t('serverError')
                        }
                    }
                }
                this.loading =false
            }
        },
    }
}
</script>
